import { Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputLabel, List, ListItem, ListItemSecondaryAction, ListItemText, MenuItem, Paper, Select, TextField, Tooltip, Typography } from '@mui/material'
import React, { useContext, useMemo, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { deleteMail, SendToDepartment, SendToUsername } from '../../api/request/dashboard/dashboard';
import toast from 'react-hot-toast';
import { deleteEmail } from '../../store/Slices/emailsSlice';
import createMailCell from '../../components/tablecells/Mailbox';
import { Search } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DeleteMail from '../../components/tab/tabview/mail/DeleteMail';
import ViewMail from '../../components/tab/tabview/mail/ViewMail';
import ReactQuill from 'react-quill';

export default function MailComponent() {
  const [open, setOpen] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const [content, setContent] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [mailToDelete, setMailToDelete] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedRecipientType, setSelectedRecipientType] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [subject, setSubject] = useState("");
  const [viewOpen, setViewOpen] = useState(false);
  const [mailToView, setMailToView] = useState(null);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { t } = useTranslation()
  const { emails = [], users = [], departments = [] } = useSelector(state => state.email, shallowEqual);
  const dispatch = useDispatch();

  const handleOpen = () => { setOpen(true); };

  const handleClose = () => {
    setSelectedDepartment("");
    setSelectedRecipientType('');
    setContent("");
    setSubject('');
    setOpen(false);
  };


  const handleChange = (value) => {
    setContent(value);
    console.log("Content updated:", value);
  };

  const quillModules = {
    toolbar: [
      [{ size: [] }], ["bold", "italic", "underline", "strike"], [{ list: "ordered" }, { list: "bullet" }],
      ["blockquote", "code-block"], ["link", "image"], [{ align: [] }], ["clean"],
    ],
  };

  const quillFormats = ["font", "size", "bold", "italic", "underline", "strike", "list", "bullet", "blockquote", "code-block", "link", "image", "align",];

  const handleDeleteOpen = (mail) => {
    setMailToDelete(mail);
    setDeleteOpen(true);
  };

  const handleViewOpen = (mail) => {
    setMailToView(mail);
    setViewOpen(true);
  }

  const handleDelete = async () => {
    if (!mailToDelete) {
      console.error("No mail selected for deletion.");
      return;
    }

    const data = { id: mailToDelete.id };

    try {
      const response = await deleteMail(data);
      console.log("Response:", response);

      if (response.status === 200) {
        toast.success("Mail deleted successfully!", {
          duration: 2000,
          position: "top-right",
        });

        dispatch(deleteEmail(mailToDelete.id));

        setTimeout(() => {
          setDeleteOpen(false);
        }, 1500);
      }
    } catch (error) {
      console.error("Error deleting mail:", error);
      toast.error("Failed to delete mail.");
    }
  };


  const handleRecipientTypeChange = (event) => {
    setSelectedRecipientType(event.target.value);
  };

  const handleDepartmentChange = (event) => {
    setSelectedDepartment(event.target.value);
    console.log("Selected department:", event.target.value);
  };

  const selectedUserDetails = users.find(user => user.id === selectedUser);

  const handleSendMail = async () => {

    if (!subject || !content || (!selectedDepartment && !selectedUser)) {
      toast.error("Please fill in all fields.");
      return;
    }

    try {
      const data = {
        content: content,
        departmentId: selectedDepartment,
        subject: subject,
      };


      const dataForuser = {
        content: content,
        subject,
        toUserType: selectedUserDetails ? selectedUserDetails.senderType : null,
        toUsername: selectedUser,
      }
      const response = await (selectedRecipientType === "department"
        ? SendToDepartment(data)
        : SendToUsername(dataForuser));

      if (response.status === 200) {
        toast.success("Mail sent successfully!");
      } else {
        toast.error("Failed to send mail.");
      }

      handleClose();
    } catch (error) {
      console.error("Error sending mail:", error);
      // toast.error("Error sending mail.");
    }
  }; 
  const handleToggleSearchBar = () => {
    setShowSearchBar(prev => !prev);
    setSearchQuery('');
  };

  const filteredEmails = useMemo(() => {
    return emails.filter(
      (email) =>
        email.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
        email.senderName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [emails, searchQuery]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
        <Box flex={1} display="flex" justifyContent="center">
          <Typography sx={{ color: darkMode ? "var(--lightText)" : "var(--darkText)" }}>{t('mailBox')}</Typography>
        </Box>
        <Tooltip title={t('newEmail')}>
          <IconButton onClick={handleOpen}><AddCircleOutlineIcon sx={{ fontSize: "20px" }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Divider />

      <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff" }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 0, width: "100%", padding: 0, backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>
            <TextField size="small" variant="outlined" placeholder="Search here..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1 }} />
          </Paper>
        </Box>

      </Box>

      <List sx={{ width: '100%', bgcolor: darkMode ? "#151924" : "#fff", padding: 0 }}>
        {filteredEmails.map((email, index) => (
          <React.Fragment key={index}>
            <ListItem alignItems="flex-start">
              <ListItemText primary={
                <>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {email.unread && (<FiberManualRecordIcon sx={{ fontSize: 12, color: 'primary.main' }} />)}
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? "var(--lightText)" : "var(--darkText)" }}>{email.subject}</Typography>
                  </Box>
                </>
              }
                secondary={
                  <>
                    <Typography variant="body2" color="textSecondary">{email.senderUsername} • {new Date(email.dateTime).toLocaleString()}</Typography>
                  </>
                }
              />

              <ListItemSecondaryAction>
                {createMailCell({ handleOpen, handleDeleteOpen, handleViewOpen, t }).find(c => c.field === 'actions')?.render(email)}
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <Box>
          <DialogTitle sx={{ color: "white", p: 1 }} className="bg-primary">
            <Typography id="symbol-details-modal" variant="body1" sx={{ color: darkMode ? "var(--white)" : "var(--white)" }} align="center">{t('newEmail')}</Typography>
          </DialogTitle>
          <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", height: "400px", display: 'flex', gap: 2, flexDirection: 'column' }}>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 2, mt: 3 }}>

              <FormControl fullWidth>
                <InputLabel>{t('enterrecipient')}</InputLabel>
                <Select label={t('enterrecipient')} value={selectedRecipientType} onChange={handleRecipientTypeChange} fullWidth variant="outlined" sx={{ height: 45 }}>
                  <MenuItem value="department">{t('department')}</MenuItem>
                  <MenuItem value="client">{t('client')}</MenuItem>
                </Select>
              </FormControl>

              {selectedRecipientType === "department" && (
                <FormControl fullWidth>
                  <InputLabel>{t('selectDepartment')}</InputLabel>
                  <Select label={t('selectDepartment')} value={selectedDepartment} onChange={handleDepartmentChange} fullWidth variant="outlined" sx={{ height: 45 }}>
                    {departments.map((department, index) => (
                      <MenuItem key={index} value={department.id}>{department.description}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {selectedRecipientType === "user" && (
                <FormControl fullWidth>
                  <InputLabel>{t('selectClient')}</InputLabel>
                  <Select label={t('selectClient')} value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} fullWidth variant="outlined" sx={{ height: 45 }}>
                    {users.map((user, index) => (
                      <MenuItem key={index} value={user.id}>{user.description}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              <TextField label={t('entersubject')} placeholder={t('entersubject')} variant="outlined" fullWidth value={subject} onChange={(e) => setSubject(e.target.value)} sx={{ "& .MuiOutlinedInput-root": { height: 45 } }} />
              <ReactQuill value={content} onChange={handleChange} theme="snow" placeholder={t('writeyourmessage')} modules={quillModules} formats={quillFormats} style={{ height: "200px", marginBottom: "2px", color: darkMode ? "#fff" : "#000", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }} />
            </Box>

          </DialogContent>
          <DialogActions sx={{ padding: "16px", backgroundColor: darkMode ? "#151924" : "#f5f5f5" }}>
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <Button onClick={handleClose} variant="outlined" color="primary" sx={{ marginRight: 2 }}>{t('cancel')}</Button>
              <Button onClick={handleSendMail} variant="contained" color="primary">{t('send')}</Button>
            </Box>
          </DialogActions>
        </Box>
      </Dialog>
      <DeleteMail open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDelete={handleDelete} />
      <ViewMail open={viewOpen} handleClose={() => setViewOpen(false)} mail={mailToView} />

    </>
  )
}
